module.exports = __webpack_public_path__ + "00_mole.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/00_mole.png
// module id = lBYY
// module chunks = 0